import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import StudentStudyQualityGauge from './StudentStudyQualityGauge';
import { StudentStudyQualityListService } from '../../services/CustomerSuccessKpiListService';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';

class StudentStudyQualityGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    StudentStudyQualityListService.load();
  }

  render() {
    return (
      <StudentStudyQualityGauge
        loading={
          StudentStudyQualityListService.fetchCurrent.fetching || StudentStudyQualityListService.fetchPrevious.fetching
        }
        currentValue={toJS(StudentStudyQualityListService.global.current)}
        previousValue={toJS(StudentStudyQualityListService.global.previous)}
        onClickHistory={() => CustomerSuccessHistoryService.openDialog('STUDENT_STUDY_QUALITY')}
        formatter={StudentStudyQualityListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentStudyQualityGaugeContainer);
